enum MenuItemEnum {
  Unknown = "Unknown",
  CustomProject = "CustomProject",
  DesktopTutorial = "DesktopTutorial",
  QESTutorial = "QESTutorial",
  LookupGeography = "LookupGeography",
  LookupAddress = "LookupAddress",
  AccuracyEvidence = "AccuracyEvidence",
  //ProviderResults = "ProviderResults",
  Project = "Project",
  Cacdi = "Cacdi",
  Censuses = "Censuses",
  Termination = "Termination",
  //Targeting = "Targeting",
  //Exclusions = "Exclusions",
  Exceptions = "Exceptions",
  Providers = "Providers",
  Members = "Members",
  Reports = "Reports",
  Software = "Software",
  Data = "Data",
  Admin = "Admin",
  Adhoc = "Adhoc",
  Directory = "Directory",
  ManageClient = "ManageClient",
  ManageGroups = "ManageGroups",
  ManageUsers = "ManageUsers",
  ManageLicenses = "ManageLicenses",
  Manifest = "Manifest",
  MyUploads = "MyUploads",
  UploadProviders = "UploadProviders",
  UserSessions = "UserSessions",
  AccessReports = "AccessReports",
  AccessReportsAdmin = "AccessReportsAdmin",
  Targeting = "Targeting",
  Operations = "Operations",
  Performance = "Performance",
  NetworkOutreach = "NetworkOutreach",
  EditProjects = "EditProjects",
  EnterpriseComplianceDashboard = "EnterpriseComplianceDashboard",
  ManageTags = "ManageTags",
  // external link, doesn't need to be highlighted as active
  ContactUs = "ContactUs",
  // download link, doesn't need to be highlighted as active
  QesUserGuide = "QesUserGuide",
  CompetitiveInsightsDashboard = "CompetitiveInsightsDashboard",
  InternalReports = "Internal Reports",
  ReportPresets = "Report Presets",
}

export default MenuItemEnum;
